// Mock content and configuration for the Mitolyn clone
// NOTE: All data is static/mock – no backend is used.

export const AFFILIATE_URL = "https://d76d5dkeqlgkph3ijjv6di6ze2.hop.clickbank.net";

export const PACKAGES = [
  {
    id: "1-bottle",
    label: "BASIC",
    bottles: "1 BOTTLE",
    supply: "30 Day Supply",
    price: "$79",
    highlight: false,
    mostPopular: false,
    bonuses: [],
    freeShipping: false,
    desktopImage: "https://mitolyn.com/assets/images/1-desktop.png",
    mobileImage: "https://mitolyn.com/assets/images/1-mobile.png",
    buttonImage: "https://mitolyn.com/assets/images/generic/atc-a.png",
  },
  {
    id: "6-bottle",
    label: "MOST POPULAR",
    bottles: "6 BOTTLES",
    supply: "180 Day Supply",
    price: "$294",
    highlight: true,
    mostPopular: true,
    bonuses: ["2 FREE BONUSES!", "FREE US SHIPPING!"],
    freeShipping: true,
    desktopImage: "https://mitolyn.com/assets/images/6-desktop.png",
    mobileImage: "https://mitolyn.com/assets/images/6-mobile.png",
    buttonImage: "https://mitolyn.com/assets/images/generic/atc-b.png",
  },
  {
    id: "3-bottle",
    label: "BUNDLE",
    bottles: "3 BOTTLES",
    supply: "90 Day Supply",
    price: "$177",
    highlight: false,
    mostPopular: false,
    bonuses: ["2 FREE BONUSES!"],
    freeShipping: false,
    desktopImage: "https://mitolyn.com/assets/images/3-desktop.png",
    mobileImage: "https://mitolyn.com/assets/images/3-mobile.png",
    buttonImage: "https://mitolyn.com/assets/images/generic/atc-a.png",
  },
];

export const BONUSES = [
  {
    id: 1,
    badge: "BONUS #1",
    title: "1-Day Kickstart Detox",
    description:
      "Detox, cleanse and flush your organs to aid absorption and kickstart your Mitolyn journey with 20 bizarre 15 second detox tea recipes, using everyday ingredients from your kitchen.",
    image: "https://mitolyn.com/assets/images/book-1.jpg",
  },
  {
    id: 2,
    badge: "BONUS #2",
    title: "Renew You",
    description:
      "With your brand-new fast-tracked body comes a new mindset. Discover simple methods you can do right now to instantly relieve stress and calm your mind, boost confidence and reduce anxiety.",
    image: "https://mitolyn.com/assets/images/book-2.jpg",
  },
];

export const INGREDIENTS = [
  {
    id: "maqui",
    name: "Maqui Berry",
    tagline:
      "exotic purple fruit packed full of the special antioxidant anthocyanin",
    image: "https://mitolyn.com/assets/images/ing_maqui.jpg",
    bullets: [
      "Promotes mitochondria",
      "Supports a healthy heart",
      "Supports healthy cholesterol",
    ],
  },
  {
    id: "rhodiola",
    name: "Rhodiola",
    tagline:
      "adaptogen bursting with over 140 polyphenols like rosavin and salidroside",
    image: "https://mitolyn.com/assets/images/ing_rho.jpg",
    bullets: [
      "Promotes mitochondria",
      "Reduces stress & improves mood",
      "Supports brain health",
    ],
  },
  {
    id: "haematococcus",
    name: "Haematococcus",
    tagline:
      "unique red algae crammed full of the mighty red antioxidant astaxanthin",
    image: "https://mitolyn.com/assets/images/ing_algae.jpg",
    bullets: [
      "Promotes mitochondria",
      "Supports healthy joints",
      "Supports immune response",
    ],
  },
  {
    id: "amla",
    name: "Amla",
    tagline:
      "special fruit rich in flavonoids, antioxidants and essential nutrients",
    image: "https://mitolyn.com/assets/images/ing_amla.jpg",
    bullets: [
      "Promotes mitochondria",
      "Supports healthy digestion",
      "Supports vision",
    ],
  },
  {
    id: "epicatechin",
    name: "Cacao & Green Tea (Epicatechin)",
    tagline:
      "natural flavonoid found in cacao and green tea",
    image: "https://mitolyn.com/assets/images/ing_cacao.jpg",
    bullets: [
      "Promotes mitochondria",
      "Supports muscle performance",
      "Supports vascular health",
    ],
  },
  {
    id: "schisandra",
    name: "Schisandra",
    tagline:
      "adaptogenic berry used in traditional Chinese medicine",
    image:
      "https://customer-assets.emergentagent.com/job_fc80331a-96f2-46e1-a59f-214c25fdb97e/artifacts/4lezyicd_image.png",
    bullets: [
      "Promotes mitochondria",
      "Supports liver health",
      "Supports healthy aging",
    ],
  },
];

export const FAQS = [
  {
    id: 1,
    question: "Is Mitolyn right for me?",
    answer:
      "Do you have deep stubborn fat stores that no diet or exercise seems to remove? Then the answer is yes Mitolyn is right for you. Mitolyn has changed the lives of thousands of women and men from 18 to 80 and is designed to rapidly liquify fat in even the worst cases.",
  },
  {
    id: 2,
    question: "Is Mitolyn safe?",
    answer:
      "Mitolyn is a natural proprietary formula manufactured in the USA at our FDA registered and GMP certified facility using state of the art, precision engineered machinery and under the strictest and most sterile standards. Each ingredient is 100% plant-based, soy-free, dairy-free, non-GMO, and put through additional third-party inspections and quality control to ensure high purity and potency. As always we advise you to show a bottle of this to your doctor before you take it, just to be safe.",
  },
  {
    id: 3,
    question: "How many bottles should I order?",
    answer:
      "If you're over 35 years old or carry excess weight, we recommend you take Mitolyn for at least 3 to 6 months so it has enough time to work throughout your entire body to support healthy mitochondria levels, reach your desired weight, and lock it in for years into the future. Every 3 bottle package of Mitolyn comes with the 2 bonus books absolutely free. Or make the smart decision and get the heavily discounted 6 bottle package, which comes with the 2 bonus books absolutely free along with free shipping as well.",
  },
  {
    id: 4,
    question: "What's the best way to take Mitolyn?",
    answer:
      "Take one capsule of Mitolyn with a big glass of cold water every day. It's bespoke proprietary blend of natural ingredients will get to work dissolving fat for you even when sleeping.",
  },
  {
    id: 5,
    question: "Is this a one time payment?",
    answer:
      "Yes, your order today is a one-time payment with no auto-ship, subscriptions or hidden charges.",
  },
  {
    id: 6,
    question: "What if Mitolyn doesn't work for me?",
    answer:
      "Every single bottle of Mitolyn comes with our personal 90-day 100% money back guarantee. If for any reason you're unsatisfied with your results, just return all bottles (even if empty) for a full, no questions asked refund.",
  },
  {
    id: 7,
    question: "What do I do now?",
    answer:
      "This is the fun part. Choose one of the packages below and click through to complete your secure order.",
  },
];

export const HERO_COPY = {
  eyebrow: "Unlock Your Metabolic Power",
  title: "Burn More Calories & Feel Great With Mitolyn",
  subtitle:
    "Mitolyn is one of the only products in the world with a proprietary blend of 6 exotic nutrients and plants designed to support healthy mitochondria levels.",
};

export const GUARANTEE_COPY = {
  titleLines: ["100% Satisfaction", "90-Day Money Back Guarantee"],
  body:
    "Your order today is protected by my iron-clad 90-day 100% money-back guarantee. If you are not astonished how fast your deep stubborn fat stores melt away into pure energy, or shocked as you admire your new toned, slim body in the mirror, then at any time in the next 90 days let us know and we'll refund every single penny of your investment. No questions asked.",
  badgeImage: "https://mitolyn.com/assets/images/guarantee.png",
  logosImage: "https://mitolyn.com/assets/images/generic/icons-fda2.png",
};

// Top-hero micro reviews (Helen & Nicholas)
export const HERO_TESTIMONIALS = [
  {
    id: 1,
    name: "Helen P",
    quote: "This really works – energy's up, lbs down!",
    avatar: "https://mitolyn.com/assets/images/test-1.jpg",
  },
  {
    id: 2,
    name: "Nicholas D",
    quote: "I can actually see the results, it's incredible!",
    avatar: "https://mitolyn.com/assets/images/test-2.jpg",
  },
];

// Main testimonials section + customer images strip
export const MAIN_TESTIMONIALS = [
  {
    id: 1,
    title: "Sophie's dropped 33 lbs...",
    body:
      "I used to feel embarrassed and ashamed of my body. I avoided social events and photos because I didn't like how I looked. Thanks to Mitolyn, I've lost 33 pounds and feel confident again. I'm not hiding in the background anymore – I'm finally living my life!",
    name: "Sophie F.",
    location: "Dallas, TX",
    package: "Purchased Mitolyn 6 Bottles Package",
    mainImage: "https://mitolyn.com/assets/images/test-3.jpg",
    avatar: "https://mitolyn.com/assets/images/test-3.jpg",
  },
  {
    id: 2,
    title: "Michael's dropped 28 lbs...",
    body:
      "My weight had gotten out of hand, and I was constantly tired and unmotivated. After taking Mitolyn, I've lost 28 pounds and feel more energized than I have in years. I can move more easily, and my clothes fit better than they have in a long time.",
    name: "Michael R.",
    location: "San Diego, CA",
    package: "Purchased Mitolyn 3 Bottles Package",
    mainImage: "https://mitolyn.com/assets/images/test-4.jpg",
    avatar: "https://mitolyn.com/assets/images/test-4.jpg",
  },
  {
    id: 3,
    title: "Connie's dropped 40 lbs...",
    body:
      "Being overweight made even basic activities exhausting. I could hardly play with my kids without feeling out of breath. After using Mitolyn, I've dropped 40 pounds, and I can keep up with my kids without feeling tired all the time. I have my energy and freedom back!",
    name: "Connie A.",
    location: "Montclair, NJ",
    package: "Purchased Mitolyn 6 Bottles Package",
    mainImage: "https://mitolyn.com/assets/images/test-5.jpg",
    avatar: "https://mitolyn.com/assets/images/test-5.jpg",
  },
];

export const CUSTOMER_STRIP_IMAGES = [
  "https://mitolyn.com/assets/images/customer/8.jpg",
  "https://mitolyn.com/assets/images/customer/9.jpg",
  "https://mitolyn.com/assets/images/customer/10.jpg",
  "https://mitolyn.com/assets/images/customer/11.jpg",
  "https://mitolyn.com/assets/images/customer/12.jpg",
  "https://mitolyn.com/assets/images/customer/13.jpg",
  "https://mitolyn.com/assets/images/customer/14.jpg",
];
